export interface PasswordRules {
  minLength: number;
  requireLetter: boolean;
  requireDigit: boolean;
  requireSymbol: boolean;
  allowSpaces: boolean;
}

export interface PasswordRuleCheck {
  textKey: string;
  textParams?: { minLength: number };
  isMet: boolean;
}

const DEFAULT_MIN_LENGTH = 7;

export const DEFAULT_PASSWORD_RULES: PasswordRules = {
  minLength: DEFAULT_MIN_LENGTH,
  requireLetter: false,
  requireDigit: false,
  requireSymbol: false,
  allowSpaces: false
};

const LETTER = /\p{L}/u;
const DIGIT = /\d/;
const SYMBOL = /[^\p{L}\d\s|^]/u;
const WHITESPACE = /\s/;

export function checkPasswordRules(password: string, rules: PasswordRules): PasswordRuleCheck[] {
  const checks: PasswordRuleCheck[] = [
    {
      textKey: 'atLeastNCharacters',
      textParams: { minLength: rules.minLength },
      isMet: password.length >= rules.minLength
    }
  ];

  if (rules.requireLetter) {
    checks.push({ textKey: 'atLeastOneLetter', isMet: LETTER.test(password) });
  }
  if (rules.requireDigit) {
    checks.push({ textKey: 'atLeastOneNumber', isMet: DIGIT.test(password) });
  }
  if (rules.requireSymbol) {
    checks.push({ textKey: 'atLeastOneSymbol', isMet: SYMBOL.test(password) });
  }
  if (!rules.allowSpaces) {
    checks.push({ textKey: 'noSpaces', isMet: password.length > 0 && !WHITESPACE.test(password) });
  }

  return checks;
}
